<template>
    <el-container class="mainXxcxBody">
            <el-col class="box">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="mainTitle">存量房房合同查询</span>
                        <span class="zsText">注：两个查询条件都必须精确输入</span>
                    </div>
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="存量房合同号">
                            <el-input v-model="formInline.yshth" placeholder="存量房合同号"></el-input>
                        </el-form-item>
                        <el-form-item label="签约密码">
                            <el-input v-model="formInline.qymm" placeholder="请输入签约密码"></el-input>
                        </el-form-item>
                        <span class="cxzxClass1">
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                                <el-button @click="resetHt">重置</el-button>
                            </el-form-item>
                        </span>
                    </el-form>
                </el-card>
                <div v-show="sfxs_ht">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span class="mainTitle">序号1</span>
                        </div>
                        <div class="qfhtcxjg" :style='mypagestyle'>
                            <el-row>
                                <el-col :span="10">
                                <span class="qfhHcontent1">
                                    存量房合同号：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.HTBH}}
                                </span>
                                </el-col>
                                <el-col :span="12">
                                <span class="qfhHcontent1">
                                    套内面积：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.TNMJ}}㎡
                                </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                <span class="qfhHcontent1">
                                    转让方名称：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.CSR}}
                                </span>
                                </el-col>
                                <el-col :span="12">
                                <span class="qfhHcontent1">
                                    公摊面积：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.FTMJ}}㎡
                                </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                <span class="qfhHcontent1">
                                    受让方名称：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.MSR}}
                                </span>
                                </el-col>
                                <el-col :span="12">
                                <span class="qfhHcontent1">
                                    规划用途：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.FLYT}}
                                </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                <span class="qfhHcontent1">
                                    签约日期：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.QYDATE}}
                                </span>
                                </el-col>
                                <el-col :span="12">
                                <span class="qfhHcontent1">
                                    建筑结构：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.JZJG}}
                                </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                <span class="qfhHcontent1">
                                    成交金额：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.CJZJ}}元
                                </span>
                                </el-col>
                                <el-col :span="12">
                                <span class="qfhHcontent1">
                                    备案日期：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.BADATE}}
                                </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                <span class="qfhHcontent1">
                                    建筑面积：
                                </span>
                                    <span class="qfhHcontent2">
                                    {{htList.MJ}}㎡
                                </span>
                                </el-col>
                                <el-col :span="12">
                                <span class="qfhHcontent1">
                                    房屋坐落：
                                </span>
                                    <span class="qfhHcontent2 htfwzl">
                                    {{htList.ZL}}
                                </span>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </div>
            </el-col>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";
    export default {
        data() {
            return {
                formInline: {
                    yshth: '',
                    qymm: '',
                },
                htList:[],
                sfxs_ht:false,
                mypagestyle: {
                    backgroundImage:'url(' + require('../../img2/htyzx.png'),
                },
            }
        },
        methods: {
            ...mapActions([
                'HtxxSelect',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            onSubmit() {
                if(this.formInline.yshth !=""&&this.formInline.qymm!=""){
                    this.HtxxSelect({_module:'TT',_method:'getHtxx',htlx:"clfht",htbh: this.formInline.yshth,qymm:this.formInline.qymm}).then((res) => {
                        if (res._result.HtxxList !=null ) {
                            this.sfxs_ht=true;
                            this.htList=res._result.HtxxList;
                            if(this.htList.SFQY ==-1){
                                this.mypagestyle="";
                            }else {
                                this.mypagestyle='backgroundImage:'+'url(' + require('../../img2/htyzx.png') + ')';
                            }
                        }else{
                            this.warnMessage("没有查到信息，请检查合同号与签约密码")
                        }
                    })
                }else{
                    this.warnMessage("预售合同号与签约密码不能为空");
                }
            },
            resetHt(){
                this.formInline.yshth='';
                this.formInline.qymm='';
                this.sfxs_ht=false;
                this.mypagestyle="";
            }
        },
        created() {

        }
    }
</script>
<style>
    @import "../../assets/css/xxcx/xxcx_main.css";
</style>